<template>
    <div class="page">
        <headers :title='titles'></headers>
        <div class="textarea">
            <textarea placeholder="请输入作业要求，学生将按照要求上传书法作品图片"
                      @input="descInput"
                      v-model="contact"></textarea>
            <div class="tips c-999">{{contact.length}} / 200</div>
        </div>
        <div class="foot">
            <div class="bottom_btn"
                 :class="contact.length?'blue':'gary'">
                <a @click="send">去发布</a>
            </div>
        </div>
    </div>
</template>

<script>
import headers from 'COMPONENTS/base/header.vue'
export default {
    components: {
        headers
    },
    data () {
        return {
            dept_type: this.$route.query.dept_type || '0',
            titles: '作业要求',
            contact: ''
        }
    },
    methods: {
        //输入时触发
        descInput () {
            this.contact = this.contact.substring(0, 200);
        },
        //去发送
        send () {
            if (!this.contact.length) {
                return
            } else {
                let qid = []
                qid.push(this.contact)
                this.$store.commit('setszyzreleaseid', qid);
                if (this.dept_type) {
                    this.$router.push('/qualityStation/release/11/8?dept_type=2')
                } else {
                    this.$router.push('/qualityStation/release/11/8')
                }
            }
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.page {
    padding-bottom: 96px / $ppr;
    background: #fff;
    min-height: 100vh;
}
.textarea {
    padding: 24px / $ppr;
    position: relative;
    textarea {
        width: 100%;
        box-sizing: border-box;
        min-height: 640px / $ppr;
        background: #f2f2f2;
        border-radius: 10px / $ppr;
        padding: 20px / $ppr;
        border: 1px solid #d7d7d7;
        font-size: 28px / $ppr;
        line-height: 2;
    }
    .tips {
        position: absolute;
        bottom: 45px / $ppr;
        right: 45px / $ppr;
        color: #999;
    }
}
.foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    .bottom_btn {
        a {
            display: inline-block;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            width: 100%;
            text-align: center;
            font-size: 36px / $ppr;
        }
    }
    .blue a {
        color: #fff;
        background-color: #5e89ef;
    }
    .gary a {
        color: #999999;
        background-color: $line;
    }
}
</style>